import * as React from "react";
import { AppLayout } from "./AppLayout";
import { useTexts } from "../hooks/useTexts";
import { ContentContainer, Card } from "./common/StyledComponents";

export const WasserangebotDetailRoute = React.memo(
  function WasserangebotDetailRoute() {
    const { t } = useTexts();

    return (
      <AppLayout>
        <ContentContainer>
          <h1>
            {t("wasserangebot.detail.title", "Wasserangebot in Deutschland")}
          </h1>

          <Card>
            <p>
              {t(
                "wasserangebot.detail.intro",
                "Deutschland verfügt über ausreichende Wasserressourcen, um den Bedarf der Bevölkerung und der Wirtschaft zu decken. Die Wasserverfügbarkeit variiert jedoch regional stark."
              )}
            </p>
            <h2>
              {t(
                "wasserangebot.detail.fakten.title",
                "Wichtige Fakten zum Wasserangebot"
              )}
            </h2>
            <ul>
              <li>
                {t(
                  "wasserangebot.detail.fakten.item1",
                  "Deutschland hat jährlich etwa 188 Milliarden Kubikmeter Wasser zur Verfügung"
                )}
              </li>
              <li>
                {t(
                  "wasserangebot.detail.fakten.item2",
                  "Davon werden nur etwa 20% tatsächlich genutzt"
                )}
              </li>
              <li>
                {t(
                  "wasserangebot.detail.fakten.item3",
                  "Der größte Teil des Wassers stammt aus Grundwasser (etwa 70%)"
                )}
              </li>
              <li>
                {t(
                  "wasserangebot.detail.fakten.item4",
                  "Oberflächenwasser (Flüsse, Seen) macht etwa 30% aus"
                )}
              </li>
            </ul>
          </Card>

          <Card>
            <h2>
              {t(
                "wasserangebot.detail.regional.title",
                "Regionale Unterschiede"
              )}
            </h2>
            <p>
              {t(
                "wasserangebot.detail.regional.text",
                "Das Wasserangebot in Deutschland ist regional sehr unterschiedlich verteilt. Während der Norden und Süden reich an Wasserressourcen sind, können in östlichen Regionen zeitweise Engpässe auftreten."
              )}
            </p>
          </Card>

          <Card>
            <h2>
              {t("wasserangebot.detail.zukunft.title", "Zukunftsaussichten")}
            </h2>
            <p>
              {t(
                "wasserangebot.detail.zukunft.text",
                "Der Klimawandel beeinflusst das Wasserangebot in Deutschland. Experten rechnen mit veränderten Niederschlagsmustern und möglicherweise längeren Trockenperioden in bestimmten Regionen."
              )}
            </p>
          </Card>
        </ContentContainer>
      </AppLayout>
    );
  }
);
